import { ErrorState, Notice } from '@agency/ui';
import { ApiClientError } from './api.ts';

/** Maps a query error to the right state: permission-restricted, network, or generic with request ID. */
export function QueryError({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const e = error instanceof ApiClientError ? error : null;
  if (e?.status === 403) return <ErrorState title="You don’t have access to this" message="Your role doesn’t include the permission needed here. Ask an Owner or Administrator if you need it." requestId={e.requestId} />;
  if (e?.code === 'NETWORK') return <ErrorState title="You appear to be offline" message={e.message} onRetry={onRetry} />;
  return <ErrorState title="Could not load this data" message={`${e?.message ?? 'Unexpected error.'} Your filters and selection are kept; nothing has been lost.`} requestId={e?.requestId} onRetry={e?.retryable === false ? undefined : onRetry} />;
}
export function ConflictNotice({ message, onReload, live = true }: { message: string; onReload: () => void; live?: boolean }) {
  return (
    <Notice live={live} tone="warning" title="Changed elsewhere">
      {message} <button type="button" className="ag-btn ag-btn--sm" onClick={onReload}>Reload latest</button>
    </Notice>
  );
}
